import React from "react";
import { observer } from "mobx-react";
import { BookingEventLogStore } from "./BookingEventLogStore";
import { EventLog_BookingEventFragment as Event } from "@graphql";
import { BookingEvent } from "./BookingEvent/BookingEvent";
import CommentBox from "../CommentBox/CommentBox";
import { EventLogLayout } from "../components/EventLogLayout";

type Props = {
  id: string;
  onUpload?: () => any;
  uploadDisabled?: boolean;
};

@observer
class BookingEventLog extends React.Component<Props> {
  eventStore: BookingEventLogStore = new BookingEventLogStore(this.props.id);

  componentDidMount(): void {
    this.eventStore = new BookingEventLogStore(this.props.id);
  }

  componentWillUnmount() {
    this.eventStore.unsubscribe();
  }

  renderCommentBox = () => {
    return (
      <CommentBox
        onComment={this.eventStore.addComment}
        withButtons={["comment" /*, "reminder", "metInPerson", "SMS","chat", "mail"*/]}
        // onFilter={store.setEventTypeFilter}
        // filterOptions={store.eventTypes}
        // selectedFilter={store.eventTypeFilter}
        skipReminder
      />
    );
  };

  renderEvent = (event: Event) => {
    return <BookingEvent item={event} store={this.eventStore} />;
  };

  renderList = () => {
    return (
      <div>
        {this.eventStore.events.map((item) => (
          <div key={item._id}>{this.renderEvent(item)}</div>
        ))}
      </div>
    );
  };

  render() {
    return (
      <div style={{ padding: "16px" }}>
        <EventLogLayout
          loading={this.eventStore.isLoading}
          commentBox={this.renderCommentBox()}
          list={this.renderList()}
          search=""
        />
      </div>
    );
  }
}

export default BookingEventLog;
